import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import AspectRatioRounded from '@mui/icons-material/AspectRatioRounded';
import { Box, FormControl, IconButton, MenuItem, Select, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { SYNC_SIGNATURE_HARVEST_MAP, USER_TYPE } from '../../../../utils/constants';
import SyncSignatureHarvestModal from './SyncSignatureHarvestModal';
import CardMedia from '@mui/material/CardMedia';
import Premium from '../../../../assets/images/PRO logo PMS green only.svg';
import { useState } from 'react';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';
import styles from './styles';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { containsAnyKeys } from '../../../../utils/objectHelpers';
import { epicorSyncSignatureHarvest } from '../../../../store/actions/epicor/epicorSyncSignatureHarvest';

const syncSignatureHarvestPermittedRoles = [
  USER_TYPE.PREMIUM_ADMIN,
  USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
  USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER
];

const SyncSignatureHarvest = () => {
  const [open, setOpen] = useState(false);
  const classes = styles();
  const user = useSelector((state) => state.currentUser);
  const epicorBins = useSelector((state) => state.epicorBins);
  const syncSignatureHarvest = useSelector((state) => state.epicorSyncSignatureHarvest);
  const dispatch = useDispatch();
  const isAdminUser = syncSignatureHarvestPermittedRoles.includes(user.type) || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && containsAnyKeys(syncSignatureHarvestPermittedRoles, user.accessLevels));

  if (!isAdminUser) {
    return null;
  }

  const handleAspectRatio = useAspectRatio();
  const { preferences } = useSelector((state) => state.currentUser);

  const handleOpenModal = () => {
    setOpen(true);
    dispatch({
      type: REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleCloseModal = () => {
    setOpen(false);
    dispatch({
      type: REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleSyncSignatureHarvest = () => {
    let Division;
    if (syncSignatureHarvest.syncSignatureHarvestDivision) {
      Division = String(syncSignatureHarvest.syncSignatureHarvestDivision);
    }
    dispatch(epicorSyncSignatureHarvest(Division));
  };

  const handleChange = (e) => {
    dispatch({
      type: REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_DIVISION,
      payload: e.target.value,
    });
  };

  const handleClear = () => {
    dispatch({
      type: REDUX_ACTIONS.EPICOR_SYNC_SIGNATURE_HARVEST_DIVISION,
      payload: '',
    });
  };

  return (<Box>
    <Box className={classes.container}>
      <IconButton
        onClick={() => {
          handleOpenModal();
        }}
        disabled={epicorBins.loading === true}
      >
        <BorderColorRoundedIcon />
      </IconButton>
      <IconButton
        onClick={() => {
          handleAspectRatio(!preferences.aspectChanged);
        }}
      >
        <AspectRatioRounded />
      </IconButton>
    </Box>
    {open
      ? (
        <SyncSignatureHarvestModal
          open={open}
          onClose={handleCloseModal}
          handleClose={handleCloseModal}
          cta2Label={'Sync'}
          cta2Disabled={syncSignatureHarvest.syncSignatureHarvestStatus === 'loading'}
          cta2Action={handleSyncSignatureHarvest}
          showCta2={syncSignatureHarvest.syncSignatureHarvestStatus !== 'success'}
          showDateTimeRange={false}
        >
          <CardMedia
            component="img"
            image={Premium}
            className={classes.logo}
          />

          <Typography variant="h3" gutterBottom component="div" className={classes.title}>
            Sync Unsigned Tickets?
          </Typography>

          <Box className={classes.divisionContainer}>
            <Typography variant='body2' className={classes.divisionText}>Division</Typography>
            <FormControl variant='outlined' sx={{ minWidth: '180px' }}>
              <Select
                labelId="simple-select-standard-label"
                id="simple-select-standard"
                value={syncSignatureHarvest.syncSignatureHarvestDivision}
                onChange={handleChange}
                onClick={(e) => {
                  if (syncSignatureHarvest.syncSignatureHarvestDivision && e.target.getAttribute('data-value') === syncSignatureHarvest.syncSignatureHarvestDivision) {
                    handleClear();
                  }
                }}
                size='small'
                sx={{
                  '& .MuiSelect-select': {
                    padding: '14px',
                  },
                }}
                disabled={syncSignatureHarvest.syncSignatureHarvestStatus === 'loading'}
                displayEmpty
              >
                <MenuItem value="">
                  None
                </MenuItem>
                {Object.entries(SYNC_SIGNATURE_HARVEST_MAP)
                  .sort(([aKey], [bKey]) => Number(aKey) - Number(bKey))
                  .map(([key, value]) => (
                    <MenuItem key={`item_${key}`} value={key}>
                      {value}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>

          {syncSignatureHarvest.syncSignatureHarvestResponseMessage !== ''
            ? <Typography variant="h5" gutterBottom component="div" className={classes.statusMessage}>
              {syncSignatureHarvest.syncSignatureHarvestResponseMessage}
            </Typography>
            : <Box style={{
              height: 40,
            }} />
          }
        </SyncSignatureHarvestModal>
        )
      : null}
  </Box>
  );
};

export default SyncSignatureHarvest;
